/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import LinkToKyc from "./LinkToKyc.container";

export default LinkToKyc;
